export default __webpack_public_path__ + "static/media/quality.db429325.png";